import { FormGroup, Validators } from '@angular/forms';

import { ServiceValidationAction } from './service-validation-action.enum';
import { FieldValidatorsMap, FormValidatorsMap } from '../interfaces';

import { ObjectLike } from 'app/interfaces';
import { FormModel } from 'app/models';

export class ServiceRules extends FormModel<ServiceValidationAction> {
    baseValidators: FieldValidatorsMap = {
        description: [],
        name: [Validators.required],
        vat: [Validators.required, Validators.min(0), Validators.max(100)],
        category: [Validators.required],
    };
    formValidators: FormValidatorsMap = {};

    getStoreForm(formFrom: ObjectLike = {}): FormGroup {
        return this.createFormGroup(ServiceValidationAction.Store, formFrom);
    }

    getUpdateForm(formFrom: ObjectLike = {}): FormGroup {
        return this.createFormGroup(ServiceValidationAction.Update, formFrom);
    }
}
